import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import { Button } from '@/components/ui'
import type { TApplyingFinancingAgentFormSuccessProps } from '../../types'
import { SuccessMore } from './components'
import { messages } from './messages'
import './styles.scss'

const ApplyingFinancingAgentSuccessNew: React.FC<TApplyingFinancingAgentFormSuccessProps> = ({
  onReset,
  navItems,
  requestID,
  className,
  buttonClassName,
  descriptionClassName,
}) => {
  return (
    <div className={classNames(className, 'applyingFinancingAgentSuccess')}>
      <SuccessMore buttonClassName={buttonClassName} descriptionClassName={descriptionClassName} navItems={navItems} />

      <div className="applyingFinancingAgentSuccess__buttons">
        <Button onClick={onReset} modifiers={['outline-gray', 'full-width-mobile']}>
          {messages.buttons.close}
        </Button>
        <CommonLink url={`/profile/funding-requests/${requestID}`} className="button button_green button_full-width-always">
          {messages.buttons.to_finance}
        </CommonLink>
      </div>
    </div>
  )
}

export default ApplyingFinancingAgentSuccessNew
